export const ALL_ESPORTS_ALIAS = 'AllESports';

export const ALL_ESPORT_SPORTS = [
  'CounterStrike',
  'LeagueOfLegends',
  'Dota2',
  'StarCraft2',
  'EBasketball',
  'CyberFootball',
  'CrossFire',
  'KingOfGlory',
  'PUBG',
  'WarcraftIII',
  'RainbowSix',
  'MobileLegends'
];
